import { receive } from '@/api/ajax';
import OpenNewWin from '@/tools/openNewWin';

export default {
  data() {
    return {
      watchFlag: false,
      finishFlag: 0
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.path.includes('recordDetail')) {
      next();
    } else {
      let value = this.tableData;
      if (
        from.name !== 'spreadRecordList' &&
        !this.finishFlag == 1 &&
        !this.finishFlag == 2
      ) {
        this.makeSureEvent(
          _,
          value,
          '<span>您尚未完成所有任务记录审核</span><br/><span>是否继续退出?</span>',
          {
            center: true,
            dangerouslyUseHTMLString: true,
            confirmButtonText: '继续退出',
            cancelButtonText: '取消',
            callback: (action, instance) => {
              if (action === 'cancel') {
                next(false);
              } else {
                next();
              }
            }
          }
        );
      } else {
        next();
      }
    }
  },
  mounted() {
    // console.log('mounted');
    // this.$router.beforeEach((to,from,next)=>{
    //   console.log(to,from,next);
    //   next()
    // })
  },
  watch: {
    tableData: function(value) {
      if (this.watchFlag) {
        this.approveCheck();
      }
    }
  },
  methods: {
    signContract() {
      //签约
      let win = new OpenNewWin();
      win.createWin();
      receive
        .signStatement({
          statementId: this.$route.query.statementId,
          signType: this.$route.query.signType
        })
        .then(res => {
          win.setUrl(res.data.data);
          this.$confirm(
            '请在新打开的页面完成签约，签约成功请点击完成',
            '提示',
            {
              confirmButtonText: '完成',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              this.watchFlag = false;
              this.initWatchRouteChange();
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
              this.watchFlag = false;
              this.initWatchRouteChange();
            });
        });
    },
    approveCheck(value) {
      value = this.tableData;
      if (this.$route.query.signType == 2 && this.finishFlag !== 0) {
        // signType 线下全部操作成功 全部拒绝
        this.makeSureEvent(
          _,
          value,
          `<span>您已完成所有任务记录审核` + (this.finishFlag !== 2
            ? `<br/>请线下签署结算单后同步给平台工作人员`
            : ''),
          {
            center: true,
            // title:'接收任务',
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            showCancelButton: false,
          } 
        );
      } else if (this.$route.query.signType == 1 && this.finishFlag == 1) {
        //线上 全部审核完-成功
        this.$message.success('您已完成所有任务记录审核');
        if (this.$route.query.isNeedSeal == 0) {
          this.makeSureEvent(
            _,
            value,
            '<span>您已完成所有任务记录审核</span><br/>',
            {
              center: true,
              // title:'接收任务',
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              showCancelButton: false,
              callback: (action, instance) => {
                if (action === 'confirm') {
                  // this.signContract()
                  this.$router.go(-1);
                }
              }
            }
          );
        } else {
          this.makeSureEvent(
            _,
            value,
            '<span>您已完成所有任务记录审核</span><br/>',
            {
              center: true,
              // title:'接收任务',
              dangerouslyUseHTMLString: true,
              confirmButtonText: '签署结算单',
              cancelButtonText: '稍后签署',
              callback: (action, instance) => {
                if (action === 'confirm') {
                  this.signContract();
                }
              }
            }
          );
        }
      } else if (this.finishFlag == 2) {
        // 全部审核完-不成功
        this.$message.success('您已完成所有任务记录审核');
        this.makeSureEvent(
          _,
          value,
          '<span>您已完成所有任务记录审核</span><br/>',
          {
            center: true,
            // title:'接收任务',
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            showCancelButton: false,
          }
        );
      } else if (this.finishFlag == 3) {
        // 单章
        this.$message.success(
          '您已完成所有任务记录审核,由于您驳回了部分任务记录,现需要服务商发起新的结算单'
        );
        this.makeSureEvent(
          _,
          value,
          '<span>您已完成所有任务记录审核</span><br/><span>由于您驳回了部分任务记录</span><br/><span>现需要服务商发起新的结算单</span>',
          {
            center: true,
            // title:'接收任务',
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            showCancelButton: false,
            callback: (action, instance) => {
              if (action === 'confirm') {
                this.$router.go(-1);
              }
            }
          }
        );
      } else if (this.finishFlag == 4) {
        // 4 双章
        this.$message.success(
          '您已完成所有任务记录审核,由于您驳回了部分任务记录,现需要您重新发起新的结算单'
        );
        this.makeSureEvent(
          _,
          value,
          '<span>您已完成所有任务记录审核</span><br/><span>由于您驳回了部分任务记录</span><br/><span>现需要您重新发起新的结算单</span>',
          {
            center: true,
            // title:'接收任务',
            dangerouslyUseHTMLString: true,
            confirmButtonText: '发起结算单',
            cancelButtonText: '稍后签署',
            callback: (action, instance) => {
              if (action === 'confirm') {
                this.signContract();
              }
            }
          }
        );
      }
    },
    approve(type, data, isAll = 0, $event) {
      receive
        .receiveTaskRecord({
          auditGongyeStatus: type,
          remark: $event,
          isAll: isAll,
          statementId: this.$route.query.statementId,
          taskRecordId: data.id
        })
        .then(response => {
          this.finishFlag = +response.data.data; // 0全部审核未完成 1全部通过 2全部不通过 3单章部分通过 4双章部分通过
          this.$message.success(response.data.message);
          this.watchFlag = true;
          this.searchEvent();
        });
    },
    receiveAll() {
      receive
        .receiveTaskRecord({
          statementId: this.$route.query.statementId,
          isAll: 1,
          auditGongyeStatus: 2
        })
        .then(response => {
          this.finishFlag = +response.data.data;
          this.watchFlag = true;
          this.searchEvent();
        });
    }
  },
  filters: {
    transTag(val) {
      if (val == 0) {
        return '差';
      } else if (val == 1) {
        return '一般';
      } else if (val == 2) {
        return '积极';
      } else if (val == 3) {
        return '好';
      } else if (val == 4) {
        return '很好';
      }
    },
    transAuditStatus(val) {
      if (val == 1) {
        return '审核中';
      } else if (val == 2) {
        return '审核通过';
      } else if (val == 3) {
        return '审核未通过';
      }
    }
  },
  created() {}
};
